import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import { IconButton, Stack, Typography } from "@mui/material";

export interface IMultiItemNavigationHeaderProps {
  title: string;
  currentIndex: number;
  totalCount: number;
  onDelete: () => void;
}

export const MultiItemNavigationHeader = ({
  title,
  currentIndex,
  totalCount,
  onDelete,
}: IMultiItemNavigationHeaderProps) => (
  <Stack direction="row" sx={{ alignItems: "center", justifyContent: "space-between" }}>
    <Typography variant="subtitle1SemiBold" sx={{ color: "primary.main" }}>
      {title} - {currentIndex + 1} / {totalCount}
    </Typography>
    <IconButton onClick={onDelete} size="small">
      <DeleteOutlineIcon />
    </IconButton>
  </Stack>
);
